import { z } from "zod";

const MonthlyDataSchema = z.object({
    month: z.string().regex(/^(19|20)\d{2}-(0[1-9]|1[0-2])$/, {
        message: "month must be in YYYY-MM format (e.g. 2025-03)",
    }),
    room_type_id: z.string().nullable(),
    occupancy: z.coerce.string().regex(/^\d+(\.\d+)?$/, {
        message: "occupancy must be a decimal number in string form",
    })
});

// Define schema for the entire response
const OccupancyMonthResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(MonthlyDataSchema),
});

type OccupancyMonthResponse = z.infer<typeof OccupancyMonthResponseSchema>;

export { OccupancyMonthResponseSchema };
export type { OccupancyMonthResponse };